export const MAX_DRAFT_TRANSCRIPT_LENGTH = 20_000;

export const MAX_DRAFT_CONTEXT_LENGTH = 65_536;

export const SIMULATION_NAME_MAX = 128;

export const SIMULATION_TEXT_MAX = 10_000;

export interface SimulationDraftBody {
  transcript: string;
  starting_context?: string;
}

export interface SimulationDraft {
  name: string;
  scenario: string;
  pass_criteria: string;
}
